import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import type { quantityDropdownValue } from '/business/shared/components/pages/question/types';
import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_NUMBER,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useScope1Data({
  isAbsoluteUnits = false,
  dropdownValues,
}: {
  isAbsoluteUnits: boolean;
  dropdownValues: quantityDropdownValue[];
}): StaticSharedField {
  const { t } = useTranslation();

  return {
    type: FIELD_TYPE_NUMBER,
    inputMode: 'decimal',
    step: '.01',
    label: <span>Scope 1 emissions:</span>,
    propName: 'scope1_data_amount',
    element: 'scope1_data_amount',
    subLabel: <span>(Direct emissions)</span>,
    // set to ' ', as we're using label as JSX, so if placeholder gets set to component it becomes object [object]
    placeholderI18nKey: ' ',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOSCOPE1EMISSIONS',
        errStr: t('business:Errors.supplierForm.scope1Intensity'),
      },
      {
        rule: ERR_TYPE_NUM_SMALL,
        errCode: 'ERRSCOPE1EMISSIONSTOOLOW',
        errStr: t('business:Errors.supplierForm.scope1Intensity'),
        value: 0,
      },
      {
        rule: ERR_TYPE_NUM_LARGE,
        errCode: 'ERRSCOPE1EMISSIONSTOOHIGH',
        errStr: t('business:Errors.supplierForm.scope1Intensity'),
        value: 9999999,
      },
    ],
    dropdown: {
      propName: 'scope1_data_amount_unit',
      values: dropdownValues,
    },
  };
}
